import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-red-ribbon-club', templateUrl: './red-ribbon-club.component.html', styleUrls: ['./red-ribbon-club.component.scss'] })
export class RedRibbonClubComponent implements OnInit { constructor() { } ngOnInit(): void { } }
